/** Agent-config-surface product events (spec 68 §6.6.3). */
import { z } from 'zod';
import { DEFAULT_SCHEMA_VER, id, microusd } from './_shared.js';

export const agentEvents = {
  'agent.installed': {
    schema: z.object({
      account_id: id,
      project_id: id,
      agent_id: id,
      template_slug: z.string().optional(),
      is_proxy: z.boolean(),
    }),
    schemaVer: DEFAULT_SCHEMA_VER,
  },
  'agent.status_changed': {
    schema: z.object({
      account_id: id,
      agent_id: id,
      old_status: z.string().min(1),
      new_status: z.string().min(1),
    }),
    schemaVer: DEFAULT_SCHEMA_VER,
  },
  'agent.revoked': {
    schema: z.object({ account_id: id, agent_id: id }),
    schemaVer: DEFAULT_SCHEMA_VER,
  },
  'agent.secret_rotated': {
    schema: z.object({ account_id: id, agent_id: id, rotated_by_user_id: z.string().optional() }),
    schemaVer: DEFAULT_SCHEMA_VER,
  },
  'agent.model_set': {
    schema: z.object({
      account_id: id,
      agent_id: id,
      model_slug: id,
      fallbacks: z.array(z.string()).optional(),
    }),
    schemaVer: DEFAULT_SCHEMA_VER,
  },
  'agent.budget_set': {
    schema: z.object({
      account_id: id,
      agent_id: id,
      cap_microusd: microusd,
      window: z.string().optional(),
    }),
    schemaVer: DEFAULT_SCHEMA_VER,
  },
  'agent.connection_granted': {
    schema: z.object({
      account_id: id,
      agent_id: id,
      connection_id: id,
      connection_kind: z.string().min(1),
    }),
    schemaVer: DEFAULT_SCHEMA_VER,
  },
  'agent.connection_revoked': {
    schema: z.object({ account_id: id, agent_id: id, connection_id: id }),
    schemaVer: DEFAULT_SCHEMA_VER,
  },
  'agent.skill_exposed': {
    schema: z.object({ account_id: id, agent_id: id, skill_fqn: z.string().min(1) }),
    schemaVer: DEFAULT_SCHEMA_VER,
  },
  'agent.triggers_set': {
    schema: z.object({
      account_id: id,
      agent_id: id,
      cron_enabled: z.boolean().optional(),
      webhook_enabled: z.boolean().optional(),
    }),
    schemaVer: DEFAULT_SCHEMA_VER,
  },
  'agent.webhook_rotated': {
    schema: z.object({ account_id: id, agent_id: id }),
    schemaVer: DEFAULT_SCHEMA_VER,
  },
} as const;
